<template>
    <el-card class="full-width-card" shadow="always" :body-style="{padding: '0'}" v-loading="loading">
        <!--        <div>-->
        <!--            if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){-->
        <!--            filename = hallObjInfo.addinfo11-->
        <!--            }else{-->
        <!--            filename = hallObjInfo.addinfo12-->
        <!--            }-->
        <!--        </div>-->

        <ul class="card-ul">
            <li>
                <h4>{{recordname}}</h4>
            </li>
            <li class="img-part" v-if="null != imgUrl">
                <div class="hall-img-box">
                    <img :src="imgUrl">
                </div>
            </li>
            <li class="info-part" v-if="null != obj.country">
                <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>
            </li>

            <li class="info-part">
                <span tkey="主辦方">{{i18n.tkey("lang_sponsor")}}</span> : <span>{{companyname}}</span>
            </li>

            <li class="info-part">
                <span tkey="邀請鏈接">{{i18n.tkey("lang_invite_url")}}</span> : <span><CopyUrlButton :url="invUrl" /><QrcodePopoverButton :url="invUrl" /></span>
            </li>

            <li class="des-part">
                <span tkey="展館描述">{{i18n.tkey("lang_hall_des")}}</span> : <span>{{addinfo7}}</span>
            </li>

            <li class="operation-box">
                <el-button @click="clickView" v-show="false" tkey="查看">{{i18n.tkey("lang_check")}}</el-button>
                <el-button type="primary" @click="clickEditBtn" tkey="修改">{{i18n.tkey("lang_modify")}}</el-button>
              <el-button v-if="obj.recordno == -1" @click="clickGoOrderBtn" type="primary" plain tkey="訂單">{{i18n.tkey("lang_custom_order")}}</el-button>
            </li>
        </ul>
    </el-card>
</template>

<script setup>

import {computed, inject, ref, toRef, getCurrentInstance} from "vue";
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import {useUserinfo} from "@/stores/userinfo";
import QrcodePopoverButton from "@/components/shopopee/button/qrcodePopoverButton.vue";
import CopyUrlButton from "@/components/shopopee/button/copyUrlButton.vue";
import myUtil from "@/util/util";

library.add(faLocationDot)

const i18n = inject("i18n")

const props = defineProps(["obj"])
const emits = defineEmits(["clickView", "clickEdit","clickGoOrder"])

const loading = ref(false)
const userInfoRef = toRef(useUserinfo())

const { proxy } = getCurrentInstance()

const recordname = computed(() => {
    let name = props.obj.recordname

    if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
        name = props.obj.addinfo6
    }

    return name
})

const addinfo7 = computed(() => {
    let name = props.obj.addinfo7

    if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
        name = props.obj.addinfo8
    }

    return name
})

const companyname = computed(() => {
    let name = "3DShopopee"

    if (myUtil.isNotEmpty(props.obj.companyname) && props.obj.companycode !== "ZZ"){
        name = props.obj.companyname2

        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(name)){
            name = props.obj.companyname
        }
    }

    return name
})

const countryname = computed(() => {
    let name = props.obj.country.countryname

    if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
        name = props.obj.country.countryname2
    }

    return name
})

const invUrl = computed(() => {
    return `${proxy.$ThreeDShopopeePath}inviteMall/${props.obj.id}`
})

function clickView() {
    emits("clickView", props.obj)
}

function clickEditBtn() {
    emits("clickEdit", props.obj)
}
function clickGoOrderBtn(){

  emits("clickGoOrder", props.obj)
}

const imgUrl = computed(() => {
    let url = props.obj.addinfo11

    if(userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
        url = props.obj.addinfo12
        if(myUtil.isEmpty(url)){
            url = props.obj.addinfo11
        }
    }

    return url
})

</script>

<style scoped>
.full-width-card {
    width: 100%;
}

.card-ul {
    list-style: none;
    padding-left: 0;
    text-align: left;
    padding: 10px;
}

.operation-box {
    text-align: center;
    margin-top: 15px;
}

.info-part {
    line-height: 2;
    color: #606266;
}

.des-part {
    height: 4.5em;
    line-height: 1.5;
    overflow: hidden;
    color: #606266;
}

.icon-span {
    color: #79bbff;
}

.additionlrecord14-img{
    width: 100%;
}
.img-part .hall-img-box {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding-top: 50%;
}

.img-part .hall-img-box img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: fill;
    top: 0;
    left: 0;
    border: 1px #E4E7ED solid;
}
</style>